import { IconX } from '@tabler/icons-react';
import React from 'react';
import { PwaDownloadIcon } from '../assets/icons/';
import { useLocalStorageStore } from '../stores/localStorageStore';
import { MixpanelEvent, sendPostHogEvent } from '../utils/mixpanelUtil';

const PWAInstallBanner = ({ isVisible, onInstall, onClose }) => {
  const handleClose = () => {
    setTimeout(() => {
      const parsedData =
        useLocalStorageStore.getState().pwaInstallDeeplink || {};
      MixpanelEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
        },
        true
      );
      sendPostHogEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
        },
        true
      );
      onClose();
    }, 300); // Match this with the transition duration
  };

  return (
    <div
      className={`absolute -top-10 z-[1000] max-w-[400px] transform transition-all duration-300 ease-in-out ${
        isVisible ? 'translate-y-[70px]' : '-translate-y-full'
      } left-5 right-5 sm:left-1/2 sm:-translate-x-1/2`}
    >
      <div className='relative rounded-lg bg-[rgb(26,27,30,0.95)] p-4 text-white shadow-lg'>
        <div className='flex items-center justify-between gap-2'>
          <div className='flex items-center space-x-6'>
            <img
              src={PwaDownloadIcon}
              alt='PWA Download Icon'
              className='h-10 w-10'
            />
            <span className='text-poppins-14'>
              Install PadhAI on your Phone for easy access.
            </span>
          </div>
          <div className='flex flex-shrink-0 items-center justify-end'>
            <button
              onClick={onInstall}
              className='rounded-full bg-white px-4 py-2 text-poppins-medium-14 text-[#070519] transition-colors duration-200'
            >
              Install App
            </button>
          </div>
        </div>
        <button
          onClick={handleClose}
          className='absolute -right-3 -top-3 rounded-full border-2 border-[#070519] bg-[#FFB6B6] p-1 text-[#070519] transition-colors duration-200'
        >
          <IconX className='h-5 w-5' />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallBanner;
